module.exports = __webpack_public_path__ + "img/seguridad.b27cc1c5.svg";